import React from "react";
import { Download } from "lucide-react";

/**
 * Shared "Save as PDF" action button used by every calculator card.
 */
export function SavePdfButton({ lang, onClick, testId }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className="mt-4 inline-flex items-center gap-2 rounded-lg bg-sapphire-700 text-white px-4 py-2 text-[13px] font-medium hover:bg-[#0a4a72] transition-colors"
    >
      <Download className="h-4 w-4" />
      {lang === "et" ? "Salvesta PDF-i" : lang === "ru" ? "Сохранить PDF" : "Save as PDF"}
    </button>
  );
}
